import script from "./ListasClienteAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./ListasClienteAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./ListasClienteAdministrar.vue?vue&type=style&index=0&id=387a5309&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-387a5309"]])

export default __exports__